module.exports = __webpack_public_path__ + "img/appAsset-brand--sii.d503a2a2.svg";